


















import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { ApexOptions } from 'apexcharts';

export default Vue.extend({
  props: ['propertyName'],
  components: {
    apexchart: VueApexCharts,
  },
  data(): {
    histChartOptions: ApexOptions;
    histSeries: [{ name: string; data: Array<number> }];
    isOkToUseArea: boolean;
  } {
    const histBars =
      this.$store.getters.labelAnalysisResult[this.propertyName].hist.bars;
    return {
      histChartOptions: {
        chart: {
          stacked: true,
          stackType: 'normal',
          toolbar: {
            show: true,
          },
          width: '100%',
        },
        colors: ['#5BD99C'],
        xaxis: {
          position: 'bottom',
          labels: {
            show: true,
          },
          categories: Object.keys(histBars), // Keys array
        },
        yaxis: {
          labels: {
            show: true,
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: 'right',
          fontSize: '12px',
          show: true,
          inverseOrder: true,
        },
        dataLabels: {
          enabled: false,
          offsetY: -20,
          style: {
            colors: ['#192A3E'],
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top',
            },
          },
        },
      },
      histSeries: [
        {
          name: `Count`,
          data: Object.values(histBars), // Data array
        },
      ],
      isOkToUseArea: Object.keys(histBars).length > 1,
    };
  },
  computed: {},
});
